import { render } from "./UbicastIcon.vue?vue&type=template&id=1b2634f0"
import script from "./UbicastIcon.vue?vue&type=script&lang=js"
export * from "./UbicastIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__